import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle<{ $showCookieBanner: boolean }>`

  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: 'Segoe UI', sans-serif;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      -webkit-tap-highlight-color: transparent;
      -webkit-text-size-adjust: none;
      direction: ${({ theme }) => (theme.isRtl ? 'rtl' : 'ltr')};

      &::-webkit-scrollbar {
            width: 0;
      }
  }

  html {
    overflow-x: hidden;
    overscroll-behavior: none;
  }

  body {
    background-color: ${({ theme }) => theme.custom?.background || theme.colors.bodyBackground};
    overflow-x: hidden;
    position: ${({ theme }) => (theme.isRtl ? 'relative' : '')};
  }

  body > * {
    height: auto;
  }

  // Hidden helper iframes, such as the Braintree dispatch frame, declare height=0, and the rule above
  // stretched them. On RTL pages body is relative, so that height showed up below the footer
  body > iframe[height='0'] {
    height: 0;
    border: 0;
  }

  //Google Map Global Styles
  .gm-style .gm-style-iw-c {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 22px;
    transform: translate(-50%,-165%);
    max-width: unset !important;
    max-height: unset !important;
    top: 90px;


    &:focus {
      outline: none !important;
    }

  }

  //Overriding phone input styles
  .PhoneInput {
    width: 100%;
    direction: ltr;

      & > * {
        direction: ltr;
      }
  }

  .PhoneInputInput:focus {
    &:focus,
    &:visited,
    &:active {
      outline: none;
      border: 1px solid #F58A3C;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      -ms-border-radius: 12px;
    }
  }

  .PhoneInputInput {
    width: 100%;
    height: 51px;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: ${({ theme }) => theme.custom?.bodyColor || '#323232'};
    border: 1px solid ${({ theme }) => theme.custom?.headerBorder || 'rgba(212, 218, 224, 1)'};
    padding: 14px 16px;
    padding-left: 80px;
    border-radius: 12px;
    background: ${({ theme }) => theme.custom?.headerBorder || '#F6F6F6'};

    &:focus,
    &:visited,
    &:active {
      outline: none;
      border: 1px solid #F58A3C;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      -ms-border-radius: 12px;
    }

    &::placeholder {
      color: #848484;
      font-weight: 400;
    }
  }

  .PhoneInputCountry {
    display: flex;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  .PhoneInputCountrySelect {
    opacity: 0;
    position: absolute;
    left: 32px;
    z-index: 100;
    width: 15px;
    outline: none;
    border: none;
    background: transparent;
  }

  .PhoneInputCountryIcon {
    width: 28px;
    height: 20px;
  }

  .PhoneInputCountryIcon--border {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }

  .cky-consent-container {
    display: ${({ $showCookieBanner }) => ($showCookieBanner ? 'flex' : 'none')};
  }

  // CookieYes keeps its close button on the right over an RTL title, and its styles load after ours
  html[dir='rtl'] .cky-consent-container .cky-banner-btn-close {
    right: auto !important;
    left: 16px !important;
  }
`;
